import { SCREEN_ANALYTICS, ScreenAnalytics } from '@/constants/analytics'
import { AppDependencyUnrecoverableError } from '@/errors/classes/AppDependencyUnrecoverableError'
import { ErrorCode } from '@/errors/classes/ErrorCode'

type ScreenName = Pick<
  ScreenAnalytics,
  'PRINTER_NOT_SUPPORTED' | 'UNRECOVERABLE_ERROR'
>

export function getErrorScreenName(
  error: ErrorCode,
): ScreenName[keyof ScreenName] {
  if (
    error instanceof AppDependencyUnrecoverableError &&
    error.errorCodeType === 'PRINTER_NOT_SUPPORTED'
  )
    return SCREEN_ANALYTICS.PRINTER_NOT_SUPPORTED

  return SCREEN_ANALYTICS.UNRECOVERABLE_ERROR
}
